export const EVENTS = {
  RUSTORE_APPEARS: 'rustore.appears',
  REGISTER_RUSTORE_BUTTON: 'registerAccountButton.clicked',
  RUSTORE_BUTTON_CLICKED: 'rustore.button.clicked',
  MT_PIXEL: 'mt_pixel',
  //footer events
  footerNetworkClick: 'footer.networkClick',
  footerClick: 'footer.click',
  //Header events
  headerLinkClick_apps: 'appsTop.click',
  headerLinkClick_games: 'gamesTop.click',
  headerLinkClick_devs: 'devTop.click',
  headerLinkClick_help: 'supportTop.click',
  headerLinkClick: 'header.click', //Аналогична метрикам выше, но не привязана к названию кнопки
  headerAnchorClick: 'DevAnchor.click',
  headerRegisterButton: 'registerAccountButton.clicked',

  devLandingView: 'devLanding.view',
  devLandingClick: 'devLanding.click',

  //aurora os
  auroraOSLearnMoreClick: 'auroraOS.learnMore.click',

  //tools
  toolsLandingView: 'toolsLanding.view',
  toolsLandingClick: 'toolsLanding.click',
  toolsLandingStartDemoClick: 'toolsLanding.startDemo.click',
} as const;
export const YM_EVENTS = {
  HEADER_MENU_BUTTON_DEVELOPERS: 'header_menu_button_developers',
  HEADER_MENU_BUTTON_GAMES: 'header_menu_button_games',
  HEADER_MENU_BUTTON_HELP: 'header_menu_button_help',
  HEADER_MENU_BUTTON_APPS: 'header_menu_button_apps',
  DEVELOPERS_BUTTON_LOGIN: 'developers_button_login',
  DEVELOPERS_BUTTON_CHECKIN: 'developers_button_checkin',
  DEVELOPERS_BUTTON_TRY_CONSOLE: 'developers_button_try_console',
  DEVELOPERS_BUTTON_PUBLISH_APP: 'developers_button_publish_app',
} as const;
